import { EventEmitter } from '@angular/core';
import { WidgetModel } from '../models/widget.model';

export class ActiveDashboard {

    public save: () => void;

    public events = {
        change: new EventEmitter(),
    };

    public addWidget: () => void;

    public editWidget: (data: { container: number, order: number, widget: WidgetModel }) => void;

    public removeWidget: (data: { container: number, order: number, widget: WidgetModel }) => void;

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/classes/active-dashboard.ts